import anime from 'animejs/lib/anime.es.js';

  // Detect if element is inview
  var inView = function ( elements ) {

    var $window    = $(window);
    var docViewTop = $window.scrollTop() + $window.height() - ( $window.height() / 10 );

    elements.each( function( index ) {

      if ( !$(this).hasClass('over') ) {

        var elemTop = $(this).offset().top;

        if ( elemTop < docViewTop ) {

          $(this).addClass('over');

          if ( $(this).hasClass('draw-number') ) {

            //console.log('#' + $(this).attr('id'));

            anime({
              targets: '#' + $(this).attr('id'),
              loop: false,
              direction: 'alternate',
              strokeDashoffset: [anime.setDashoffset, 0],
              easing: 'easeInOutSine',
              duration: 2000,
              delay: (el, i) => { return i * 500 }
            });

          }

          if ( $(this).hasClass('typewriter') ) {
            typewriter();
          }

        }

      }

    });

  };

  inView( $('.inview') );

  $( window ).scroll( function(e) {
    inView( $('.inview') );
    inView( $('.typewriter') );
  });

  var typewriter = function() {

    $('.typewriter').each(function() {

      inView($(this));

      if ( $(this).hasClass('over') ) { 

          const element = document.querySelector('.typewriter');
          const lettersHtml = element.textContent.replace(/\S/g, '<span class="letter">$&</span>');
          element.innerHTML = '<div class="letters">'+lettersHtml + '</div><span class="cursor"></span>';
          element.style.display = 'block';

          const letters = Array.from(element.querySelectorAll('.letter'));
          const TYPE_AFTER_MS = 750;
          const JUMP_AFTER_MS = 150;
          var counter = 0;

          const blink = anime({
            targets: '.typewriter .cursor',
            loop: true,
            duration: 750,
            opacity: [
              {value: [1, 1]},
              {value: [0, 0]}
            ]
          });

          anime
            .timeline({
              loop: false
            })
            .add({
              targets: '.typewriter .cursor',
              translateX: letters.map((letter, i) =>
                ({value: letter.offsetLeft + letter.offsetWidth + 10, duration: 1, delay: i === 0 ? 0 : JUMP_AFTER_MS})),
            }, TYPE_AFTER_MS)
            .add({
              targets: '.typewriter .letter',
              opacity: [0, 1],
              duration: 1,
              color:'#002037',
              delay: anime.stagger(JUMP_AFTER_MS),
              changeBegin: (anim) => {
                console.log(anim);
                blink.reset();
                blink.pause();
              },
              changeComplete: (anim) => {
                blink.restart();
              }
            }, TYPE_AFTER_MS)
            .add({

            });

          }

    });

  }


